import i18n from '@/lang/i18n'

export default [{
  path: '/admin/install',
  name: 'Install',
  component: () => import('@/views/install/'),
  meta: {
    title: i18n.t('router.public.install_wizard'),
    keepAlive: false,
    auth: false,
    headType: -1
  }
}]



// WEBPACK FOOTER //
// ./src/router/public.js